import React, { useEffect } from "react";
import Header from "../Templete/Header";
import Footer from "../Templete/Footer";

const RefundPolicy = () => {
  useEffect(() => {
    document.title = "Refund & Cancellation Policy | FORMAX PAY";
  }, []);

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Refund & Cancellation Policy</h1>
          <p>
            Clear, fair, and transparent guidelines for refunds and
            cancellations in compliance with Indian consumer protection
            principles.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="privacy-content">
          {/* Core Policy Summary */}
          <div className="privacy-card">
            <h2>Summary of Our Policy</h2>
            <ul>
              <li>
                <strong>No Refund for Successful Transactions:</strong> FORMAX
                PAY does not offer refunds for any successfully completed
                recharge, bill payment, or voucher purchase. All sales are
                final.
              </li>
              <li>
                <strong>Auto-Refund for Failed Transactions:</strong> If a
                transaction fails due to technical issues, the full amount is
                automatically refunded to your original payment source within
                5–7 business days.
              </li>
              <li>
                <strong>No Cancellation:</strong> Once you submit a recharge or
                bill payment request, it cannot be cancelled or modified. Please
                double-check all details before confirming.
              </li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>1. Introduction & Scope</h2>
            <p>
              This Refund & Cancellation Policy applies to all services offered
              by
              <strong> FORMAX PAY</strong> (operated by{" "}
              <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>), including
              mobile recharge, DTH recharge, Google Play recharge and utility
              bill payments. By using our platform, you agree to the terms set
              forth below.
            </p>
            <p>
              This policy is governed by the laws of India and is designed to be
              fair, transparent, and compliant with the Consumer Protection
              (E-Commerce) Rules, 2020, and other applicable regulations.
            </p>
          </div>

          <div className="privacy-card">
            <h2>2. No Refund for Successful Transactions</h2>
            <p>
              FORMAX PAY has a strict <strong>no refund policy</strong> for any
              successfully completed transaction. Once a recharge, bill payment,
              or voucher purchase is successfully processed and confirmed by the
              respective operator (telecom company, DTH provider, electricity
              board, payment gateway, etc.), the amount is considered final and
              non-refundable.
            </p>
            <p>This applies to all services, including:</p>
            <ul>
              <li>Mobile Recharge (Prepaid & Postpaid)</li>
              <li>DTH Recharge</li>
              <li>Google Play Recharge</li>
              <li>
                Utility Bill Payments (Electricity, Water, Gas, Broadband, etc.)
              </li>
              {/* <li>
                Brand Vouchers (Amazon, Flipkart, Zomato, Myntra, Swiggy, etc.)
              </li> */}
            </ul>
            <p>
              <strong>Important:</strong> Please verify all details (mobile
              number, operator, consumer ID, amount, etc.) before confirming any
              transaction. No refund requests will be entertained for:
            </p>
            <ul>
              <li>Wrong mobile number or DTH ID entered</li>
              <li>Wrong operator or service provider selected</li>
              <li>Change of mind after payment</li>
              <li>Duplicate submission by the user</li>
              <li>Incorrect amount recharged</li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>3. Auto-Refund for Failed Transactions</h2>
            <p>
              If a transaction fails due to technical issues from our end, the
              operator's end, or the payment gateway, the full amount will be
              <strong> automatically refunded</strong> to your original payment
              source (credit/debit card, UPI, net banking) within
              <strong> 5–7 business days</strong>.
            </p>
            <p>
              <strong>
                You do not need to request a refund for failed transactions.
              </strong>
              Our system automatically detects transaction failures and
              initiates the refund. You will receive a notification via email or
              SMS once the refund is processed.
            </p>
            <p>
              <strong>What qualifies as a failed transaction?</strong>
            </p>
            <ul>
              <li>
                You receive a clear "Transaction Failed" message on our
                platform.
              </li>
              <li>
                The amount is debited from your bank/UPI/card, but no
                confirmation or service credit is provided within 15 minutes.
              </li>
              <li>
                The transaction is marked as "pending" or "error" in our system
                for more than 30 minutes.
              </li>
            </ul>
            <p>
              <strong>Note:</strong> If the amount is not refunded automatically
              within 7 business days, please contact our support team with the
              transaction ID.
            </p>
          </div>

          <div className="privacy-card">
            <h2>4. No Cancellation of Recharge or Bill Payment</h2>
            <p>
              <strong>No cancellation requests will be accepted</strong> once a
              recharge or bill payment request is submitted. All recharges and
              payments are processed instantly by our system, and we do not
              support cancellation for any reason, including:
            </p>
            <ul>
              <li>Wrong mobile number or DTH subscriber ID entered</li>
              <li>Wrong operator or circle selected</li>
              <li>Change of mind after payment confirmation</li>
              <li>Duplicate submission (accidental double payment)</li>
              <li>Lower or higher amount recharged than intended</li>
              <li>Delayed delivery (if eventually successful)</li>
            </ul>
            <p>
              We strongly recommend reviewing all details carefully on the
              confirmation screen before clicking the <strong>"Pay Now"</strong>{" "}
              or
              <strong> "Recharge"</strong> button. Once the transaction is
              initiated, it cannot be reversed.
            </p>
          </div>

          <div className="privacy-card">
            <h2>5. Undelivered Service After Successful Payment</h2>
            <p>
              If your transaction shows as <strong>"Success"</strong> on our
              platform but the service (recharge, bill payment, or voucher code)
              is not delivered within <strong>15 minutes</strong>:
            </p>
            <ul>
              <li>
                Contact our support team immediately with your transaction ID,
                registered mobile number, and details of the service.
              </li>
              <li>
                We will verify with the respective operator or partner. If the
                operator confirms the transaction <strong>failed</strong>, we
                will process a refund as per Section 3 (Auto-Refund).
              </li>
              <li>
                If the operator confirms the transaction{" "}
                <strong>succeeded</strong>, the service will be delivered within
                24 hours. You will be notified via SMS or email.
              </li>
            </ul>
            <p>
              This process is not a cancellation request but a service delivery
              issue resolution. We aim to resolve all such cases within 48
              hours.
            </p>
          </div>

          <div className="privacy-card">
            <h2>6. Chargebacks & Disputes</h2>
            <p>
              If you initiate a chargeback with your bank or payment provider
              without first contacting us, we reserve the right to provide
              transaction evidence to the bank. Successful transactions (as per
              our records and operator confirmation) will not be refunded via
              chargeback.
            </p>
            <p>
              We encourage you to always reach out to our support team before
              filing a dispute with your bank. We are committed to resolving
              legitimate issues fairly and promptly.
            </p>
          </div>

          <div className="privacy-card">
            <h2>7. Refund Processing Time & Method</h2>
            <p>
              Approved refunds (auto-refunds for failed transactions) are
              processed within 5–7 business days from the date of transaction
              failure. The refund will be credited to the{" "}
              <strong>original payment source</strong>
              used for the transaction. Depending on your bank or payment
              gateway, it may take an additional 2–3 days for the amount to
              reflect in your statement.
            </p>
            <p>
              Refunds are always processed to the same account/card/UPI ID from
              which the payment was made. We do not issue refunds via cash,
              cheque, or any alternative method.
            </p>
          </div>

          <div className="privacy-card">
            <h2>8. Grievance Redressal</h2>
            <p>
              If you have any complaint regarding refunds, cancellations, or
              undelivered services, you may contact our Grievance Officer:
            </p>
            <p>
              <strong>Name:</strong> Mr. Ezazul Haque (Compliance Officer)
              <br />
              <strong>Email:</strong> support@formaxpay.in
              <br />
              <strong>Phone:</strong> +91 7890090500
              <br />
              <strong>Address:</strong> N0060, Mochpole, Near Junior School,
              Nabapally, Barasat, Kolkata - 700126, West Bengal, India
            </p>
            <p>
              We will acknowledge your complaint within 24 hours and strive to
              resolve it within one month, as per the Consumer Protection
              (E-Commerce) Rules, 2020.
            </p>
          </div>

          <div className="privacy-card">
            <h2>9. Contact Us</h2>
            <p>
              For any questions regarding this Refund & Cancellation Policy,
              please contact:
            </p>
            <p>
              <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>
              <br />
              N0060, Mochpole, Near Junior School, Nabapally, Barasat,
              <br />
              Kolkata - 700126, West Bengal, India
              <br />
              Email: support@formaxpay.in
              <br />
              Phone: +91 7890090500
              <br />
            </p>
          </div>
        </div>
      </div>

      <Footer />

      {/* CSS for the page */}
      <style>{`
        .page-hero {
          background: linear-gradient(120deg, #eef2ff 0%, #f0f9ff 100%);
          padding: 50px 0 60px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 12px;
        }
        .page-hero p {
          color: #334155;
          max-width: 600px;
          margin: 0 auto;
        }
        .privacy-content {
          margin: 60px 0;
        }
        .privacy-card {
          background: white;
          border-radius: 28px;
          padding: 32px;
          margin-bottom: 30px;
          box-shadow: var(--shadow-sm, 0 10px 25px -5px rgba(0,0,0,0.05));
          border: 1px solid #eef2ff;
        }
        .privacy-card h2 {
          font-size: 1.6rem;
          margin-bottom: 16px;
          color: #0f172a;
        }
        .privacy-card p {
          margin-bottom: 16px;
          line-height: 1.6;
          color: #334155;
        }
        .privacy-card ul {
          margin-left: 24px;
          margin-bottom: 8px;
        }
        .privacy-card li {
          margin-bottom: 10px;
          line-height: 1.5;
          color: #334155;
        }
        .privacy-footer-note {
          text-align: center;
          margin-top: 30px;
          font-size: 0.9rem;
          color: #64748b;
        }
        @media (max-width: 720px) {
          .page-hero h1 { font-size: 2rem; }
          .privacy-card h2 { font-size: 1.3rem; }
          .privacy-card { padding: 24px; }
        }
      `}</style>
    </>
  );
};

export default RefundPolicy;
